import React, { useState, useRef, useEffect } from "react";
import { setPopup } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";
import "./ResetPassword.scoped.scss";
import * as TagManager from "core/common/seo/tagManager";
// Utils
import * as Utils from "core/common/utils";
// Components
import { openPopup } from "components/Popup/Popup";

const ResetPassword = ({ isMobile }) => {
  const { state, dispatch, authRepository } = useStore();
  const { business } = state;
  // const { recaptchaRef } = state.recaptcha;
  //const [recaptchaResponse, setRecaptchaResponse] = useState("");
  ////const submitRef = useRef();

  //   useEffect(() => {
  //     Utils.recaptchaHelper(dispatch, setRecaptchaResponse, submitRef);
  // }, []);

  const handleResetSubmit = async () => {
    // if (Utils.recaptchaExecute(recaptchaResponse, recaptchaRef)) return;

    try {
      Utils.loadingWrapper(dispatch, async () => {
        const { data: responseData } =
          (await authRepository.forgetPassword(business.email, "")) || {};

        TagManager.sendGoogleEvent({
          page: window.location.pathname,
          category: `${state.pageType} - ${business.business_id}`,
          action: "Reset password button",
        });

        if (!Utils.isSuccessfulRequest(dispatch, responseData)) {
          openPopup(
            dispatch,
            "משהו השתבש.",
            "לא הצלחנו לשלוח את מייל השחזור ללקוח. אנא פנה לשירות",
            "סגירה",
            () => dispatch(setPopup({ isOpen: false }))
          );
          TagManager.sendGoogleEvent({
            category: state.pageType,
            action: "Reset password button",
            label: "failed",
          });
          return;
        }

        openPopup(
          dispatch,
          "איפוס סיסמה",
          "לינק לאיפוס סיסמה נשלח לכתובת המייל של הלקוח",
          "סגירה",
          () => dispatch(setPopup({ isOpen: false }))
        );

        TagManager.sendGoogleEvent({
          category: state.pageType,
          action: "Reset password button",
          label: "succeeded",
        });
      });
    } finally {
    }
  };

  return (
    <button
      className="business_details_reset_password"
      onClick={handleResetSubmit}
    >
      {!isMobile ? " איפוס סיסמא ללקוח" : "איפוס סיסמא"}
    </button>
  );
};

export default ResetPassword;
